
//export redux objects

import vidfleetConfigurationRedux from 'Modules/vidfleet/.components/configuration/redux/reducer';
import maintenanceWarningsVidfleetRedux from 'Modules/vidfleet/views/maintenanceWarnings/redux/reducer';
import cameraLogsRedux from 'Modules/vidfleet/views/cameraLogs/redux/reducer';
import dmsStatusesRedux from 'Modules/vidfleet/views/dmsStatuses/redux/reducer';
import powerLostRedux from 'Modules/vidfleet/views/powerLost/redux/reducer';
import sdCardStatusRedux from 'Modules/vidfleet/views/sdCardStatus/redux/reducer';
import whiteListedDevicesRedux from 'Modules/vidfleet/views/whiteListedDevices/redux/slice';
import restrictionsModalRedux from 'Modules/vidfleet/.components/restrictionsModal/redux/reducer';
import cloneSettingsModalRedux from 'Modules/vidfleet/.components/cloneSettingsModal/redux/reducer';
import vidfleetConfigurationUploadModeRedux from 'Modules/vidfleet/.components/configurationUploadMode/redux/reducer';
import showChangesHistoryRedux from 'Modules/vidfleet/.components/showChangesHistory/redux/reducer';
import vidfleetConfigurationHubSpotRedux from 'Modules/vidfleet/.components/configurationHubSpot/redux/reducer';
import configurationPreviewRedux from '../../.components/configurationPreview/redux/slice';

//export redux objects
export default {
	vidfleetConfigurationRedux,
	maintenanceWarningsVidfleetRedux,
	cameraLogsRedux,
	dmsStatusesRedux,
	powerLostRedux,
	sdCardStatusRedux,
	whiteListedDevicesRedux,
	restrictionsModalRedux,
	cloneSettingsModalRedux,
	vidfleetConfigurationUploadModeRedux,
	showChangesHistoryRedux,
	vidfleetConfigurationHubSpotRedux,
	configurationPreviewRedux
};